import React, { Component } from 'react';
import ResetSuccessComponent from '../../components/auth/ResetSuccess';
const ResetSuccess = () => {
  return <div className="w-full py-16 bg-gray-100" data-id="element-611">
      <div className="container mx-auto px-4" data-id="element-612">
        <ResetSuccessComponent data-id="element-613" />
      </div>
    </div>;
};
export default ResetSuccess;